import { render, staticRenderFns } from "./formColourTag.vue?vue&type=template&id=23e1155a&"
import script from "./formColourTag.vue?vue&type=script&lang=js&"
export * from "./formColourTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports